export const diamond = () => (
  <path
    d="M2.045 9.511 12 20.177l9.955-10.666-4.977-5.688H7.022zm19.91 0H2.045M12 20.177l4.267-10.666L12 3.823 7.734 9.51z"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
